import type { TUserSubscriptionInfoStore } from '@/types/profile';

import { initialAsyncState } from '@/store/async/initialState';

export const initialState: TUserSubscriptionInfoStore = initialAsyncState({
  currentPlan: undefined,
  nextPlan: undefined,
});
